/**
 * 君が探してるのはproject.action.tsかもしれないよ？
 */
import {Action} from '@ngrx/store';
import {QueryParamsModel} from '../_base/crud';
import {ProjectModel} from '../models/project.model';

export enum DashboardActionTypes {
    LOAD_PROJECTS = '[Dashboard Feature] Emit to load a list of projects',
    CANCEL_LOAD_PROJECTS = '[Dashboard Feature] Emit to cancel loading a list of projects',
    PROJECTS_LOADING = '[Dashboard Feature] True while the projects are being loaded',
    PROJECTS_LOADED = '[Dashboard Feature] Emitted after a list of projects has been loaded',
    PROJECTS_BUSY = '[Dashboard Feature] True while an action on the project list is running',
    CLEAR_DASHBOARD = '[Dashboard Feature] Emit to clear a list of projects of dashboard',
    UPDATE_PROJECT_IS_READ = '[Dashboard Feature] update project is read or not'
}

export class LoadProjectsAction implements Action {
    readonly type = DashboardActionTypes.LOAD_PROJECTS;

    constructor(public payload: { page: QueryParamsModel<ProjectModel> }) {
    }
}

export class CancelLoadProjectsAction implements Action {
    readonly type = DashboardActionTypes.CANCEL_LOAD_PROJECTS;
}

export class ProjectsLoadingAction implements Action {
    readonly type = DashboardActionTypes.PROJECTS_LOADING;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class ProjectsLoadedAction implements Action {
    readonly type = DashboardActionTypes.PROJECTS_LOADED;

    constructor(public payload: { 
        projects: ProjectModel[], 
        isReadStatus: any, 
        totalCount: number, 
    }) {
    }
}

export class ProjectsBusyAction implements Action {
    readonly type = DashboardActionTypes.PROJECTS_BUSY;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class UpdateProjectIsReadAction implements Action {
    readonly type = DashboardActionTypes.UPDATE_PROJECT_IS_READ;

    constructor(public payload: {projectId: number, isRead: boolean }) {
    }
}

export class ClearDashboardAction implements Action {
    readonly type = DashboardActionTypes.CLEAR_DASHBOARD;
}

export type DashboardActions = LoadProjectsAction
    | CancelLoadProjectsAction
    | ProjectsLoadingAction
    | ProjectsLoadedAction
    | ProjectsBusyAction
    | UpdateProjectIsReadAction
    | ClearDashboardAction;
